import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

// Единая шапка страницы — как в макете "Диспетчерская.dc.html": заголовок+подзаголовок
// слева, вкладки/поиск/кнопки действий справа (свободный слот, у каждой страницы свои)
export default function PageHeader({ title, subtitle, children }: PageHeaderProps) {
  return (
    <div className="page-header">
      <div className="page-header-titles">
        <h1>{title}</h1>
        {subtitle && <div className="page-header-subtitle">{subtitle}</div>}
      </div>
      {children && <div className="page-header-actions">{children}</div>}
    </div>
  );
}
